import axios from "axios";
import { actions } from "../app/modules/Auth";
import store from "../redux/store";

// Response interceptor
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            store.dispatch(actions.logout());
            localStorage.clear();
            // window.location.reload(true);
        }
        return Promise.reject(error);
    }
);
